export const endPoints = {
  GET_MSG_SMSBOT: '/v1/smsBot/message/byLead',
  DELETE_MSG_SMSBOT: '/v1/smsBot/message'
};
